import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const m = {
  display: "block"
}, g = ({ size: e = 16, useVw: n, useRem: c, color: l, withColor: o, removeClassName: t, disableSSR: d, style: r, ...p }) => {
  const w = r ? { ...m, ...r } : m;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: d }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-GTwakuangnew", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (c ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (c ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: w, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-GTæç¿new"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: o ? i(l, 0, "#262933") : "#262933",
        datafollowfill: o ? i(l, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M12.332 6.061c5.489-1.47 11.13 1.787 12.601 7.276a.9.9 0 0 0 1.739-.466c-1.728-6.45-8.357-10.276-14.806-8.548C5.416 6.05 1.589 12.68 3.317 19.129c1.728 6.45 8.357 10.276 14.807 8.548a.9.9 0 0 0-.466-1.738c-5.49 1.47-11.131-1.787-12.602-7.276-1.47-5.489 1.787-11.13 7.276-12.602Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M28.09 17.78a.9.9 0 0 1 .27 1.244l-.304.471a5.873 5.873 0 0 1 1.82 3.244.9.9 0 1 1-1.767.341 4.08 4.08 0 0 0-1.047-2.04l-4.282 6.652a.9.9 0 0 1-1.513-.974l4.301-6.683a4.08 4.08 0 0 0-2.262-.203.9.9 0 1 1-.341-1.767 5.873 5.873 0 0 1 3.591.435l.29-.45a.9.9 0 0 1 1.244-.27Zm-12.785-1.475h3.229v-3.23h-3.23v-2.151a5.381 5.381 0 1 0 5.382 5.381h-2.152a3.229 3.229 0 1 1-3.23-3.23v3.23Z"
        }
      )
    )
  )));
}, k = g;
export {
  k as default
};
